if (!customElements.get('product-gifts')) {
  customElements.define(
    'product-gifts',
    class ProductGifts extends HTMLElement {
      connectedCallback() {
        this.tooltipElement = this.querySelector('[data-gifts-tooltip]');
        if (!this.tooltipElement) return;

        this.toggleButtonElement = this.querySelector('[data-gifts-tooltip-toggle]');
        this.sliderElement = this.querySelector('[data-slider-selector]');
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);

        this.toggleButtonElement?.addEventListener('click', (event) => {
          this.toggle(!this.tooltipElement.classList.contains('gifts-block__tooltip-trigger--open'), event);
        });

        this.querySelectorAll('[data-gift-item]').forEach((giftElement) => {
          giftElement
            .querySelector('input')
            ?.addEventListener('click', (event) => this.handleDoubleTap(giftElement, event));
        });
      }

      disconnectedCallback() {
        this.stopDismissListeners();
      }

      toggle(isOpen, originatingEvent) {
        this.tooltipElement.classList.toggle('gifts-block__tooltip-trigger--open', isOpen);
        this.toggleButtonElement?.setAttribute('aria-expanded', isOpen);

        if (!isOpen) {
          this.openingEvent = null;
          this.stopDismissListeners();
          return;
        }

        this.openingEvent = originatingEvent;
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onDocumentKeydown);
      }

      handleDoubleTap(giftElement, event) {
        const tappedAt = Date.now();
        const isSecondTap = this.lastTappedGiftElement === giftElement && tappedAt - this.lastTappedAt < 400;
        this.lastTappedGiftElement = giftElement;
        this.lastTappedAt = tappedAt;
        if (!isSecondTap) return;

        this.lastTappedAt = 0;
        this.slideTo(giftElement.dataset.giftProductId);
        this.toggle(true, event);
      }

      slideTo(giftProductId) {
        const swiper = this.sliderElement?.swiper;
        if (!swiper || !giftProductId) return;

        const index = Array.from(swiper.slides).findIndex(
          (slideElement) => slideElement.dataset.giftProductId === giftProductId
        );
        if (index >= 0) swiper.slideTo(index);
      }

      stopDismissListeners() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
      }

      onDocumentClick(event) {
        if (event === this.openingEvent) return;
        if (this.tooltipElement.contains(event.target)) return;
        this.toggle(false);
      }

      onDocumentKeydown(event) {
        if (event.key !== 'Escape') return;
        this.toggle(false);
      }
    }
  );
}
